import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { RitBlockButtons, TextBlockButton } from '../RitBlockButton';
import { isDisabled } from '../../utils/controls';

const TextBlockComponent = (options) => {
    let type = null
    if (options.meta.valid) {
        type = "success"
    } else if (options.meta.visited) {
        type = "error"
    }

    const [activeEnum, setactiveEnum] = useState(options.input.value);

    const onChange = (value) => {
        setactiveEnum(value);
        options.input.onChange(value)
    }

    const {label, displayName, hideTitle, disabled} = options;

    return (
        <div className='b-rit-form-group'>
            {!hideTitle && <p className='b-rit-form-group__title'>{displayName}</p>}
            <div className='b-rit-list list--text'>
                {options.values.map((item, i) => {
                    if (options.excludedAttrs.indexOf(item.attrValue) > -1) {
                        return false;
                    }
                    return (
                        <RitBlockButtons
                            key={i}
                            value={item.attrValue}
                            checked={item.attrValue == activeEnum}
                            onChange={onChange}
                            themeClass={'item-theme--text'}
                            disabled={isDisabled(disabled, item.attrValue)}
                        >
                            <TextBlockButton
                                value={item.shortName}
                            />
                        </RitBlockButtons>
                    )
                })}
            </div>
        </div>
    )
}

TextBlockComponent.propTypes = {
    displayName: PropTypes.string,
    hideTitle: PropTypes.bool.isRequired,
    disabled: PropTypes.any.isRequired,
    input: PropTypes.object.isRequired,
}

export default TextBlockComponent;